module.exports = __webpack_public_path__ + "static/media/profileAvatar.7fd59b03.svg";